export function PageControl(props) {
  // return props.children.filter((v) => v.key == props.page)
  return props.children[props.page]; //??props.children.filter((v) => v.key == props.page)
}
